import en from "./en";
import it from "./it";

const i18n = { it, en };

export default i18n;
